import { render, staticRenderFns } from "./DetailsAccountAccessPermission.vue?vue&type=template&id=49fc5564"
import script from "./DetailsAccountAccessPermission.vue?vue&type=script&lang=js"
export * from "./DetailsAccountAccessPermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports